import { FC } from 'react';
import { Box, Grid, GridItem, Text } from '@chakra-ui/react';
import { Team } from '../../../types';
import { CbParticipantSelectCard, CbParticipantSelectedCard } from './CbParticipantCards';
import { CbParticipantCardHeader } from './CbPaticipantPickerHeader';
export interface CbParticipantTeamPickerLayoutProps {
  teams: Team[];
  selectedTeams: Team[];
  selectedTeamIds: number[];
  hideButton?: boolean;
  showNotificationSettings?: boolean;
  customTeamTitle?: string;
  customTeamTitleColor?: string;
  handleAddTeam: (team: Team) => void;
  handleRemoveTeam: (index: number, id: number) => void;
  handleAddAllTeams: () => void;
  handleClearAllTeams: () => void;
  handlePrimarySelected?: (id: number, notificationsEnabled: boolean) => void;
  maxHeight?: string;
}
export const CbParticipantTeamPickerLayout: FC<CbParticipantTeamPickerLayoutProps> = ({
  teams,
  selectedTeams,
  selectedTeamIds,
  hideButton,
  showNotificationSettings,
  customTeamTitle,
  customTeamTitleColor,
  handleAddTeam,
  handleRemoveTeam,
  handleAddAllTeams,
  handleClearAllTeams,
  handlePrimarySelected,
  maxHeight
}) => {
  return <>
        <Grid width={{
      sm: '94%',
      md: '100%'
    }} templateColumns="repeat(2, 1fr)" gap={5} data-sentry-element="Grid" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx">
          <GridItem data-sentry-element="GridItem" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx">
            <CbParticipantCardHeader customTeamTitleColor={customTeamTitleColor} hideButton={hideButton} title={customTeamTitle || 'Add Team'} buttonText="Add All" listLength={teams?.length || 0} ariaLabel="Add all teams" btnColor="white" hoverColor="chonky.700" handleClick={handleAddAllTeams} data-sentry-element="CbParticipantCardHeader" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx" />

            <Box border="2px solid" borderColor="cloud.300" borderRadius={6} marginTop={4} padding={1} maxHeight={maxHeight} overflowY="auto" data-sentry-element="Box" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx">
              {teams?.map((team, index) => {
            if (!selectedTeamIds.includes(team.id)) {
              const isOddRow = (index + 1) % 2;
              return <CbParticipantSelectCard key={team.id} isOddRow={isOddRow} name={team.name} imageUrl="" handleClick={() => handleAddTeam(team)} handlePrimarySelected={() => {}} />;
            }
            return undefined;
          })}
            </Box>
          </GridItem>
          <GridItem data-sentry-element="GridItem" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx">
            <CbParticipantCardHeader hideButton={hideButton} customTeamTitleColor={customTeamTitleColor} title="Selected Teams" buttonText="Clear" listLength={selectedTeams?.length || 0} ariaLabel="Clear all teams" btnColor="cloud.900" btnBackgroundColor="none" hoverColor="cloud.500" handleClick={handleClearAllTeams} data-sentry-element="CbParticipantCardHeader" data-sentry-source-file="CbParticipantTeamPickerLayout.tsx" />
            {selectedTeams.length ? <Box border="2px solid" borderColor="cloud.300" borderRadius={6} marginTop={4} padding={1} maxHeight={maxHeight} overflowY="auto">
                {selectedTeams.map((team, index) => {
            return <CbParticipantSelectedCard key={team.id} name={team.name} notificationsEnabled={team.notificationsEnabled || false} showNotificationSettings={showNotificationSettings} imageUrl="" handleClick={() => handleRemoveTeam(index, team.id)} handlePrimarySelected={() => {
              if (handlePrimarySelected) {
                handlePrimarySelected(team.id, team.notificationsEnabled || false);
              }
            }} />;
          })}
              </Box> : <Text fontSize={{
          md: '12px'
        }} fontFamily="codenext" color={'luigisPants.200'} marginTop={6}>
                {' Please add a team '}
              </Text>}
          </GridItem>
        </Grid>
      </>;
};